// Google Consent Mode v2 helpers.
// Sets dataLayer defaults on load and updates upon user action.

export const CONSENT_STORAGE_KEY = "sb_consent_v2";

export const CONSENT_CATEGORIES = ["necessary", "analytics", "marketing", "functional"];

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  functional: false,
};

const gtag = (...args) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
};

export const initConsentDefaults = () => {
  window.dataLayer = window.dataLayer || [];
  // Set default consent state (denied) BEFORE any tag fires.
  gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
    wait_for_update: 500,
  });
  gtag("set", "ads_data_redaction", true);
};

export const updateConsent = (prefs) => {
  const state = {
    ad_storage: prefs.marketing ? "granted" : "denied",
    ad_user_data: prefs.marketing ? "granted" : "denied",
    ad_personalization: prefs.marketing ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: prefs.functional ? "granted" : "denied",
    personalization_storage: prefs.functional ? "granted" : "denied",
    security_storage: "granted",
  };
  gtag("consent", "update", state);
  window.dataLayer.push({ event: "consent_updated", consent_state: state });
};

export const readStoredConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch {
    return null;
  }
};

export const writeStoredConsent = (prefs) => {
  const value = { ...DEFAULT_CONSENT, ...prefs, necessary: true };
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(value));
  updateConsent(value);
  return value;
};
